import { Typography } from "@material-ui/core";
import React from "react";

export default () => (
  <div className="home-text-grid">
    <Typography variant="h2" className="text-background">
      <span className="f-large">Hello!</span>
      <br />
      <span className="f-medium">
        I'm{" "}
        <span
          style={{ letterSpacing: "1rem", fontSize: "100px", color: "#fec89a" }}
        >
          Aaron
        </span>
      </span>
    </Typography>

    <div></div>
    <div></div>

    <Typography variant="h5" className="white-color text-background">
      Welcome to my website!
      <br />
      <br />
      I'm a Machine Learning Engineer and Fullstack Developer.
    </Typography>
  </div>
);
